let descriptionId = 0;
class HCCollectionDescription extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    const source = this.querySelector('[data-description-content]');
    if (!source) return;
    const structuredData = [...source.querySelectorAll('script[type="application/ld+json"]')];
    structuredData.forEach(script => this.append(script));
    const clean = document.createElement('div');
    const allowed = new Set(['P','H1','H2','H3','H4','H5','H6','UL','OL','LI','A','STRONG','B','EM','I','BR','TABLE','THEAD','TBODY','TR','TD','TH','BLOCKQUOTE','SUP','SUB']);
    const more = /^(?:(?:read|see|show)\s*(?:more|less)\s*[/|▼▾⌄↓↑›»\s]*)+$/i;
    const copy = (node, parent) => {
      if (node.nodeType === Node.TEXT_NODE) { if (!more.test(node.textContent.trim())) parent.append(document.createTextNode(node.textContent)); return; }
      if (node.nodeType !== Node.ELEMENT_NODE) return;
      if (['SCRIPT','STYLE','IMG','PICTURE','VIDEO','IFRAME','SVG','INPUT','NOSCRIPT'].includes(node.tagName)) return;
      if (more.test(node.textContent.trim())) return;
      let target = parent;
      if (allowed.has(node.tagName) || ['BUTTON','SUMMARY'].includes(node.tagName)) {
        target = document.createElement(['BUTTON','SUMMARY'].includes(node.tagName) ? 'h3' : node.tagName.toLowerCase());
        if (node.tagName === 'A') {
          const href = node.getAttribute('href') || '';
          if (/^(https?:|mailto:|tel:|\/|#)/i.test(href)) target.setAttribute('href', href);
        }
        if (node.id && !['readMoreBtn','moreContent','hiddenContent'].includes(node.id)) target.id = node.id;
        parent.append(target);
      }
      for (const child of node.childNodes) copy(child, target);
    };
    for (const child of source.childNodes) copy(child, clean);
    clean.querySelectorAll('p,a,h1,h2,h3,h4,li').forEach(node => { if (!node.textContent.trim()) node.remove(); });
    source.replaceChildren(...clean.childNodes);
    const information = this.closest('.hc-hub-information,.hc-collection-information--split');
    if (information) {
      this.mountFittedDescription(source, information);
      this.dataset.ready = 'true';
      return;
    }
    const intro = source.querySelector('p');
    if (intro) {
      const range = document.createRange();
      range.setStartAfter(intro); range.setEnd(source, source.childNodes.length);
      const rest = range.extractContents();
      if (rest.textContent.trim()) {
        const body = document.createElement('div');
        body.id = `hc-description-more-${++descriptionId}`;
        body.className = 'hc-description-rest'; body.hidden = true;
        body.append(rest); source.append(body);
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'hc-description-toggle';
        button.textContent = 'Read More'; button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', body.id);
        intro.append(' ', button);
        button.addEventListener('click', () => {
          body.hidden = !body.hidden;
          button.textContent = body.hidden ? 'Read More' : 'Read Less';
          button.setAttribute('aria-expanded', String(!body.hidden));
        });
      }
    }
    if (this.closest('.hc-brand-collection-description') && intro) {
      const summary = document.createElement('div');
      summary.className = 'hc-description-mobile-summary';
      const preview = document.createElement('span');
      const introCopy = intro.cloneNode(true);
      introCopy.querySelectorAll('button').forEach(button => button.remove());
      preview.textContent = introCopy.textContent.trim();
      const toggle = document.createElement('button');
      toggle.type = 'button'; toggle.className = 'hc-description-toggle';
      toggle.textContent = 'Read More'; toggle.setAttribute('aria-expanded', 'false');
      source.id ||= `hc-description-content-${++descriptionId}`;
      toggle.setAttribute('aria-controls', source.id);
      toggle.addEventListener('click', () => {
        const expanded = this.classList.toggle('hc-mobile-description-expanded');
        toggle.textContent = expanded ? 'Read Less' : 'Read More';
        toggle.setAttribute('aria-expanded', String(expanded));
      });
      summary.append(preview, toggle); source.before(summary);
    }
    this.dataset.ready = 'true';
  }
  mountFittedDescription(source, information) {
    const originals=[...source.childNodes].map(node=>node.cloneNode(true));
    const button=document.createElement('button');
    button.type='button';button.className='hc-description-toggle';
    source.id ||= `hc-description-content-${++descriptionId}`;
    button.setAttribute('aria-controls',source.id);this.append(button);
    let expanded=false;
    const fit=()=>{
      if(!this.isConnected||!this.offsetWidth)return;
      source.replaceChildren(...originals.map(node=>node.cloneNode(true)));
      button.textContent=expanded?'Read Less':'Read More';
      button.setAttribute('aria-expanded',String(expanded));button.hidden=false;
      if(expanded)return;
      const aside=information.querySelector('aside');
      const panel=this.closest('.hc-about-panel')||information.firstElementChild;
      panel.classList.add('hc-fitted-description-panel');
      panel.style.minHeight=innerWidth>767&&aside?`${aside.offsetHeight}px`:'';
      const style=getComputedStyle(panel);
      const budget=innerWidth>767&&aside?Math.max(220,aside.offsetHeight-(source.getBoundingClientRect().top-panel.getBoundingClientRect().top)-(parseFloat(style.paddingBottom)||0)-38):300;
      let removed=false,overflow;
      while(source.scrollHeight>budget&&source.children.length>1){
        const last=source.lastChild;if(last.nodeType===Node.ELEMENT_NODE)overflow=last;
        last.remove();removed=true;
      }
      // Fill the remaining space with a word-boundary excerpt; expansion restores all markup.
      if(overflow?.tagName==='P'){
        const text=overflow.textContent.trim(),excerpt=document.createElement('p');source.append(excerpt);
        let low=0,high=text.length;
        while(low<high){const middle=Math.ceil((low+high)/2);excerpt.textContent=text.slice(0,middle)+'…';if(source.scrollHeight<=budget)low=middle;else high=middle-1;}
        const end=text.lastIndexOf(' ',low);excerpt.textContent=text.slice(0,end>0?end:low)+'…';
        if(low<20)excerpt.remove();
      }
      button.hidden=!removed;
    };
    button.addEventListener('click',()=>{expanded=!expanded;fit();});
    let frame;
    this.fitObserver=new ResizeObserver(()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(fit);});
    this.fitObserver.observe(information);const aside=information.querySelector('aside');if(aside)this.fitObserver.observe(aside);
    this.fitCleanup=()=>{cancelAnimationFrame(frame);this.fitObserver.disconnect();};
    requestAnimationFrame(fit);
  }
  disconnectedCallback(){this.fitCleanup?.();}

}
if (!customElements.get('hc-collection-description')) customElements.define('hc-collection-description', HCCollectionDescription);
